function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { NativeEventEmitter, NativeModules, Platform } from 'react-native';
const LINKING_ERROR = `The package 'react-native-now-playing' doesn't seem to be linked. Make sure: \n\n` + Platform.select({
  ios: "- You have run 'pod install'\n",
  default: ''
}) + '- You rebuilt the app after installing the package\n' + '- You are not using Expo managed workflow\n';
const NowPlayingNative = NativeModules.NowPlaying ? NativeModules.NowPlaying : new Proxy({}, {
  get() {
    throw new Error(LINKING_ERROR);
  }

});
const NowPlayingEventEmitter = new NativeEventEmitter(NowPlayingNative);

class NowPlaying {
  constructor() {
    _defineProperty(this, "callbacks", new Map());
  }

  startObserving(callback, identifier) {
    if (this.callbacks.size == 0) NowPlayingNative.startObserving();
    const listener = NowPlayingEventEmitter.addListener("NOW_PLAYING", json => {
      let nowPlaying = JSON.parse(json);
      callback(nowPlaying);
    });
    this.callbacks.set(identifier, listener);
  }

  stopObserving(identifier) {
    var _this$callbacks$get;

    (_this$callbacks$get = this.callbacks.get(identifier)) === null || _this$callbacks$get === void 0 ? void 0 : _this$callbacks$get.remove();
    this.callbacks.delete(identifier);
    if (this.callbacks.size == 0) NowPlayingNative.stopObserving();
  }

}

export default new NowPlaying();
//# sourceMappingURL=index.js.map